import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { 
  HomeIcon, 
  CogIcon, 
  DocumentTextIcon, 
  TableCellsIcon, 
  DocumentArrowDownIcon,
  ChartBarIcon,
  ArrowRightOnRectangleIcon
} from '@heroicons/react/24/outline';

const Navigation: React.FC = () => {
  const location = useLocation();
  const { logout, username } = useAuth();

  const navItems = [
    { path: '/', label: 'Dashboard', icon: HomeIcon },
    { path: '/settings', label: 'Settings', icon: CogIcon },
    { path: '/inputs', label: 'Inputs', icon: DocumentTextIcon },
    { path: '/table-packing', label: 'Table Packing', icon: TableCellsIcon },
    { path: '/constraints-analysis', label: 'Constraints Analysis', icon: ChartBarIcon },
    { path: '/outputs', label: 'Outputs', icon: DocumentArrowDownIcon },
  ];

  return (
    <nav className="bg-northwood-navy shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo/Brand */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center p-0.5">
                <img 
                  src="/squire_logo.png" 
                  alt="Squire Schedule Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h1 className="text-white font-montserrat font-bold text-xl">Squire Schedule</h1>
                <p className="text-northwood-silver text-sm">Northwood School</p>
              </div>
            </Link>
          </div>

          {/* Navigation Links */}
          <div className="flex items-center space-x-8">
            {navItems.map((item) => {
              const IconComponent = item.icon;
              const isActive = location.pathname === item.path;
              
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-montserrat font-medium transition-colors duration-200 ${ 
                    isActive 
                      ? 'text-accent-gold bg-white bg-opacity-10' 
                      : 'text-white hover:text-accent-gold hover:bg-white hover:bg-opacity-10'
                  }`}
                >
                  <IconComponent className="w-5 h-5" />
                  <span>{item.label}</span>
                </Link>
              );
            })}
            
            {/* User info and logout */}
            <div className="flex items-center space-x-4 ml-8 border-l border-white border-opacity-20 pl-8">
              <span className="text-northwood-silver text-sm">{username}</span>
              <button
                onClick={logout}
                className="flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-montserrat font-medium text-white hover:text-accent-gold hover:bg-white hover:bg-opacity-10 transition-colors duration-200"
                title="Logout"
              >
                <ArrowRightOnRectangleIcon className="w-5 h-5" />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;